import type { HttpErrorResponse } from '@angular/common/http';

import { createEntityCollectionStore, ngrxEvent } from '@core/ngrx-legacy';
import { JobBoardCredential } from '@recruitee/job-boards-types';

const { actions, namespace, selectors, reducer } =
  createEntityCollectionStore<JobBoardCredential>()('JobBoardCredentials', {
    customActions: () => ({
      credentialCreated: ngrxEvent<{
        context: { codename: string; credential: JobBoardCredential };
      }>(),
      credentialUpdated: ngrxEvent<{
        context: { codename: string; credential: JobBoardCredential };
      }>(),
      credentialDeleted: ngrxEvent<{
        context: { codename: string; credential: JobBoardCredential };
      }>(),
      credentialFailed: ngrxEvent<{ error: HttpErrorResponse }>(),
    }),
  });

export {
  actions as JobBoardCredentialActions,
  namespace as JobBoardCredentialNamespace,
  reducer as JobBoardCredentialReducer,
  selectors as JobBoardCredentialSelectors,
};
